// ============================================================================
// HEBREW TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// שאלות מהנות להרהור

export const funQuestionsHe = [
  {
    question: "איזה מעשה אהבה של ישוע נותן לך השראה הכי הרבה בחיי היומיום שלך?",
    emoji: "❤️",
    theme: "אהבה"
  },
  {
    question: "איזה היבט של בריאת אלוהים מראה לך את גדולתו ביותר?",
    emoji: "🌟",
    theme: "בריאה"
  },
  {
    question: "איזה פסוק מהתנ\"ך נתן לך נחמה בתקופה קשה?",
    emoji: "🕊️",
    theme: "נחמה"
  },
  {
    question: "מי הדמות המקראית שנותנת לך הכי הרבה השראה ולמה?",
    emoji: "⭐",
    theme: "השראה"
  },
  {
    question: "מהי הברכה שאתה הכי מודה לאלוהים עליה בחייך?",
    emoji: "🙏",
    theme: "הכרת תודה"
  },
  {
    question: "איזה משל של ישוע השפיע על המסע הרוחני שלך ביותר?",
    emoji: "📖",
    theme: "הוראה"
  },
  {
    question: "איזה היבט של אופי אלוהים הכי משמעותי בשבילך? (אהבה, צדק, רחמים...)",
    emoji: "✨",
    theme: "אופי"
  },
  {
    question: "מתי האמונה שלך התחזקה באופן בלתי צפוי?",
    emoji: "💪",
    theme: "אמונה"
  }
];

export default funQuestionsHe;
